import { IUser } from 'app/shared/model/user.model';
import { IClasse } from './classe.model';
import { IDestinataire } from './destinataire.model';
import { IEleve } from './eleve.model';

export interface INotification {
  id?: string | null;
  message?: string;
  body?: string | null;
  title?: string | null;
  unread?: boolean;
  anneeScolaireId?: string;
  typeNotification?: string | null;
  createdDate?: string | null;
  user?: IUser | null;
  ecoleId?: string;
  classes?: string[] | null;
  statutPresence?: string | null;
  etatPaiement?: string | null;
  destinataire?: IDestinataire | null;
  modeEnvoi?: number;
  matricule?: string | null;
  page?: number;
  size?: number;
}

export const defaultValue: Readonly<INotification> = {
  id: null,
  message: '',
  title: null,
  typeNotification: null,
  unread: true,
  createdDate: null,
  classes: null,
  ecoleId: '',
  anneeScolaireId: '',
  user: null,
  body: '',
  etatPaiement: null,
  statutPresence: null,
  destinataire: null,
  matricule: null,
  modeEnvoi: 0,
  page: 0,
  size: 0,
};
